export enum PulseFrequency {
  weekly = 'weekly',
  biWeekly = 'bi_weekly',
  monthly = 'monthly',
  quarterly = 'quarterly',
  sixMonthly = 'six_monthly',
  annually = 'annually',
}
